import dynamic from 'next/dynamic'
const Dialog = dynamic(
	() => import('@qr-front/ui/components/Dialog').then((mod) => mod.Dialog),
	{ ssr: false },
)
const DialogContent = dynamic(
	() =>
		import('@qr-front/ui/components/Dialog').then((mod) => mod.DialogContent),
	{ ssr: false },
)

import { useAtom, useAtomValue } from 'jotai'
import { useTranslations } from 'next-intl'
import { useState } from 'react'

import { qrCodesApi } from '@/generator/shared'

import { editQrUrlDialogAtom, editQrUrlDialogDataAtom } from '../dialogsState'
import { urlValidationSchema } from '../TableRow/commonElements'
import { EditableField } from '../TableRow/EditableField'

export const EditQrUrlDialog = () => {
	const t = useTranslations()

	const [serverError, setServerError] = useState<string>('')
	const [open, setOpen] = useAtom(editQrUrlDialogAtom)
	const editQrUrlDialogData = useAtomValue(editQrUrlDialogDataAtom)

	if (!editQrUrlDialogData) return null

	const { row, table, url } = editQrUrlDialogData

	const handleSave = async (newValue: string) => {
		try {
			setServerError('')
			await qrCodesApi.putQr(row.original.id, {
				name: row.original.name,
				content: { ...row.original.content, url: newValue },
				qrDesign: row.original.qrDesign,
			})

			if (table.options.meta?.updateData) {
				table.options.meta.updateData(row.index, 'content', {
					...row.original.content,
					url: newValue,
				})
			}
			setOpen(false)
		} catch (error: unknown) {
			// Extract error message from backend response
			const errorMessage = (
				error as { response?: { data?: { message?: unknown } } }
			)?.response?.data?.message
			if (Array.isArray(errorMessage) && errorMessage.length > 0) {
				setServerError(errorMessage[0])
			} else if (typeof errorMessage === 'string') {
				setServerError(errorMessage)
			} else {
				setServerError(t('public__backend_save_error'))
			}
		}
	}

	return (
		<Dialog open={open} onOpenChange={() => setOpen(!open)}>
			<DialogContent
				closeButtonLabel={t('ui__popup__close_button')}
				className="p-4"
				onOpenAutoFocus={(e) => {
					e.preventDefault()
				}}
			>
				<div className="flex flex-col items-center justify-center gap-6 p-2">
					<div className="flex w-full justify-start">
						<h3 className="type-heading-3">
							{t('dashboard__edit__qr_url__dialog_title')}
						</h3>
					</div>
					<div className="w-full">
						<EditableField
							value={url}
							onSave={(value) => {
								handleSave(value)
							}}
							onCancel={() => {
								setServerError('')
								setOpen(false)
							}}
							validationSchema={urlValidationSchema(t)}
							label={t('dashboard__edit__qr_url__dialog__field_label')}
							placeholder={t(
								'generator__content_form_section__website__url_placeholder',
							)}
							serverError={serverError}
						/>
					</div>
				</div>
			</DialogContent>
		</Dialog>
	)
}
